import { NotificationConfig, TExtraHTML } from '~/actions/triggers/types';
import {
  run as runUserNotification
} from '~/actions/triggers/userNotification';
import { run as runAlert } from '../../../test/triggers/alert';
import { run as runDebug } from '../../../test/triggers/debug';
import { run as runTestModal } from '../../../test/triggers/testModal';

interface ITriggers {
  debug: (scenarioName: string, configuration: ITriggerConfiguration) => void;
  alert: (scenarioName: string, configuration: ITriggerConfiguration) => void;
  testModal: (
    scenarioName: string,
    configuration: NotificationConfig
  ) => Promise<string>;
  userNotification: (
    scenarioName: string,
    configuration: NotificationConfig,
    extraHTML?: TExtraHTML
  ) => Promise<string>;
}

const triggers: ITriggers = {
  debug: runDebug,
  alert: runAlert,
  testModal: runTestModal,
  userNotification: runUserNotification,
};

export default triggers;
